import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {CommonField} from '../../shared/models/common-field';
import {LoadProgramsSuccessAction, programsActionTypes} from '../actions/program';

export interface ProgramsState {
  array: CommonField[];
}

const initialState: ProgramsState = {
  array: []
};

export function programsReducer(state: ProgramsState = initialState, action: Action): ProgramsState {
  switch (action.type) {
    case programsActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case programsActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: ProgramsState, action: LoadProgramsSuccessAction): ProgramsState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: ProgramsState): ProgramsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}


export const programsSelectors = {
  array: (state: ProgramsState) => _.get(state, 'array', [])
};
